import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { RootState } from '../../store';
import SupervisorFieldModePage from './SupervisorFieldModePage';
import AccountsPage from '../accounts/AccountsPage';
import ProcurementPage from '../procurement/ProcurementPage';
import StoresPage from '../stores/StoresPage';
import WorkerFieldWorkspacePage from './WorkerFieldWorkspacePage';
import AdminWorkerMonitorPage from './AdminWorkerMonitorPage';
import QsFieldModePage from './QsFieldModePage';
import PmFieldModePage from './PmFieldModePage';
import ExecutiveFieldModePage from './ExecutiveFieldModePage';
import AdminFieldModePage from './AdminFieldModePage';
import { canUseAdminFieldViewSwitcherForUser, effectiveFieldRoleForUser, normalizeRole } from '../../routes/fieldAccess';

export default function FieldLandingPage() {
  const user = useSelector((state: RootState) => state.auth.user);
  const role = user?.role;
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const fieldRole = effectiveFieldRoleForUser(role, searchParams.get('view'), location.pathname, user?.email);
  const adminFieldViewer = canUseAdminFieldViewSwitcherForUser(normalizeRole(role), user?.email);

  switch (fieldRole) {
    case 'admin':
    case 'field_admin':
      return <AdminFieldModePage view="home" />;
    case 'supervisor':
      return <SupervisorFieldModePage view="home" />;
    case 'accounts':
      return <AccountsPage fieldMode view="home" />;
    case 'procurement':
      return <ProcurementPage fieldMode view="home" />;
    case 'stores':
      return <StoresPage fieldMode view="home" />;
    case 'qs':
      return <QsFieldModePage view="home" />;
    case 'pm':
      return <PmFieldModePage view="home" />;
    case 'executive':
      return <ExecutiveFieldModePage view="home" />;
    default:
      if (adminFieldViewer) return <AdminWorkerMonitorPage />;
      return <WorkerFieldWorkspacePage view="home" />;
  }
}
